var chunkToChildrenMap = {
	"3524": [
		8096,
		7649,
		9797,
		9002,
		5712,
		8129
	],
	"8129": [
		8096,
		9797,
		3887,
		5255,
		3408
	],
	"9002": [
		8096,
		3887,
		572,
		3608,
		751,
		3664,
		2533,
		6765
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));